<template>
    <nav
        id="sidebar"
        :class="['sidebar-wrapper', isExpanded ? 'sidebar-expanded' : 'sidebar-collapsed']"
    >
        <div :class="['sidebar-content', { 'sidebar-content-collapsed': !isExpanded }]">
            <div class="sidebar-brand">
                <div
                    class="w-100 d-flex justify-content-center mb-2 mt-2"
                    :class="{ 'collapsed-logo': !isExpanded }"
                >
                    <img
                        class="logo-img d-flex justify-content-center"
                        src="@/assets/logo-v2.png"
                        alt="Bid Match"
                    />
                </div>
            </div>
            <!-- sidebar-header  -->
            <div class="sidebar-menu">
                <ul>
                    <li
                        :class="[
                            'sidebar-dropdown',
                            'list-menu',
                            isActive('dashboard') ? 'active' : '',
                        ]"
                    >
                        <a href="#" @click="goTo('dashboard')">
                            <font-awesome-icon :icon="['fas', 'house']" />
                            <span class="ms-2" v-if="isExpanded">Dashboard</span>
                        </a>
                    </li>
                    <li
                        :class="[
                            'sidebar-dropdown',
                            'list-menu',
                            isActive('my-quotes') ? 'active' : '',
                        ]"
                    >
                        <a href="#" @click="goTo('my-quotes')">
                            <font-awesome-icon :icon="['fas', 'magnifying-glass']" />
                            <span class="ms-2" v-if="isExpanded">My Quotes</span>
                        </a>
                    </li>

                    <!-- Substitutes -->
                    <li
                        v-if="!isRetail && !isSearchDemo"
                        :class="[
                            'sidebar-dropdown',
                            'list-menu',
                            'has-children',
                            substitutePages ? 'is-open' : '',
                            isSubstitutesRoute($route.name) ? 'active' : '',
                        ]"
                    >
                        <a href="#" @click.prevent="toggleSubstitutesPages">
                            <font-awesome-icon :icon="['fas', 'arrows-rotate']" />
                            <span class="ms-2" v-if="isExpanded">Substitutes</span>
                            <span class="more-pages-icon">
                                <font-awesome-icon
                                    :icon="['fas', substitutePages ? 'angle-up' : 'angle-down']"
                                />
                            </span>
                        </a>
                        <transition name="submenu">
                            <ul
                                v-if="substitutePages"
                                :class="[
                                    'submenu',
                                    isExpanded ? 'submenu-expanded' : 'submenu-collapsed',
                                ]"
                            >
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('substitutes-tree') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('substitutes-tree')">
                                        <font-awesome-icon :icon="['fas', 'sitemap']" />
                                        <span class="ms-2" v-if="isExpanded">Tree</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('substitutes-bad-requests') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('substitutes-bad-requests')">
                                        <font-awesome-icon :icon="['fas', 'clipboard-list']" />
                                        <span class="ms-2" v-if="isExpanded">Requests</span>
                                    </a>
                                </li>
                            </ul>
                        </transition>
                    </li>

                    <!-- Dashboards -->
                    <!-- <li
                        v-if="isRetail"
                        :class="[
                            'sidebar-dropdown',
                            'list-menu',
                            'has-children',
                            dashboardsOpen ? 'is-open' : '',
                        ]"
                    >
                        <a href="#" @click.prevent="toggleDashboards">
                            <font-awesome-icon :icon="['fas', 'chart-pie']" />
                            <span class="ms-2" v-if="isExpanded">Dashboards</span>
                            <span class="more-pages-icon">
                                <font-awesome-icon
                                    :icon="['fas', dashboardsOpen ? 'angle-up' : 'angle-down']"
                                />
                            </span>
                        </a>
                        <transition name="submenu">
                            <ul
                                v-if="dashboardsOpen"
                                :class="[
                                    'submenu',
                                    isExpanded ? 'submenu-expanded' : 'submenu-collapsed',
                                ]"
                            >
                                not used apparently
                                <li
                                    :class="[
                                        'not-used-dashboards',
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_pricing_followup') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_pricing_followup')">
                                        <font-awesome-icon :icon="['fas', 'tags']" />
                                        <span class="ms-2" v-if="isExpanded">Pricing followup</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_sales_chart') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_sales_chart')">
                                        <font-awesome-icon :icon="['fas', 'chart-pie']" />
                                        <span class="ms-2" v-if="isExpanded">Sales chart</span>
                                    </a>
                                </li>
                            </ul>
                        </transition>
                    </li>

                    <li
                        v-else
                        :class="[
                            'sidebar-dropdown',
                            'list-menu',
                            'has-children',
                            dashboardsOpen ? 'is-open' : '',
                        ]"
                    >
                        <a href="#" @click.prevent="toggleDashboards">
                            <font-awesome-icon :icon="['fas', 'chart-pie']" />
                            <span class="ms-2" v-if="isExpanded">Dashboards</span>
                            <span class="more-pages-icon">
                                <font-awesome-icon
                                    :icon="['fas', dashboardsOpen ? 'angle-up' : 'angle-down']"
                                />
                            </span>
                        </a>
                        <transition name="submenu">
                            <ul
                                v-if="dashboardsOpen"
                                :class="[
                                    'submenu',
                                    isExpanded ? 'submenu-expanded' : 'submenu-collapsed',
                                ]"
                            >
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_margin') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_margin')">
                                        <font-awesome-icon :icon="['fas', 'chart-line']" />
                                        <span class="ms-2" v-if="isExpanded">Margin Spread</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_margin_chart') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_margin_chart')">
                                        <font-awesome-icon :icon="['fas', 'chart-area']" />
                                        <span class="ms-2" v-if="isExpanded">Margin Chart</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_match_sale_quote') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_match_sale_quote')">
                                        <font-awesome-icon :icon="['fas', 'link']" />
                                        <span class="ms-2" v-if="isExpanded">Match Sale-Quote</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_po_so') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_po_so')">
                                        <font-awesome-icon :icon="['fas', 'file-invoice']" />
                                        <span class="ms-2" v-if="isExpanded">PO &amp; SO</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_purchase') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_purchase')">
                                        <font-awesome-icon :icon="['fas', 'shopping-cart']" />
                                        <span class="ms-2" v-if="isExpanded">Purchase</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dashPricingAnalysis') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dashPricingAnalysis')">
                                        <font-awesome-icon :icon="['fas', 'flask']" />
                                        <span class="ms-2" v-if="isExpanded">Pricing Analysis</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_quotes_chart') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_quotes_chart')">
                                        <font-awesome-icon :icon="['fas', 'chart-bar']" />
                                        <span class="ms-2" v-if="isExpanded">Quotes Chart</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_quotes') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_quotes')">
                                        <font-awesome-icon :icon="['fas', 'list']" />
                                        <span class="ms-2" v-if="isExpanded">Quotes Detail</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_rules') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_rules')">
                                        <font-awesome-icon :icon="['fas', 'scale-balanced']" />
                                        <span class="ms-2" v-if="isExpanded">Rules</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_rules_detail') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_rules_detail')">
                                        <font-awesome-icon :icon="['fas', 'book-open']" />
                                        <span class="ms-2" v-if="isExpanded">Rules Detail</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_sales_chart') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_sales_chart')">
                                        <font-awesome-icon :icon="['fas', 'chart-pie']" />
                                        <span class="ms-2" v-if="isExpanded">Sales Chart</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_special_pricing') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_special_pricing')">
                                        <font-awesome-icon :icon="['fas', 'tags']" />
                                        <span class="ms-2" v-if="isExpanded">Special Pricing</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_errors') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_errors')">
                                        <font-awesome-icon :icon="['fas', 'circle-exclamation']" />
                                        <span class="ms-2" v-if="isExpanded">Errors</span>
                                    </a>
                                </li>
                            </ul>
                        </transition>
                    </li> -->

                    <!-- Parts & Shipping -->
                    <!-- <li
                        v-if="!isRetail"
                        :class="[
                            'sidebar-dropdown',
                            'list-menu',
                            'has-children',
                            partsOpen ? 'is-open' : '',
                        ]"
                    >
                        <a href="#" @click.prevent="toggleParts">
                            <font-awesome-icon :icon="['fas', 'cubes']" />
                            <span class="ms-2" v-if="isExpanded">Parts &amp; Shipping</span>
                            <span class="more-pages-icon">
                                <font-awesome-icon
                                    :icon="['fas', partsOpen ? 'angle-up' : 'angle-down']"
                                />
                            </span>
                        </a>
                        <transition name="submenu">
                            <ul
                                v-if="partsOpen"
                                :class="[
                                    'submenu',
                                    isExpanded ? 'submenu-expanded' : 'submenu-collapsed',
                                ]"
                            >
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_parts') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_parts')">
                                        <font-awesome-icon :icon="['fas', 'cubes']" />
                                        <span class="ms-2" v-if="isExpanded">Parts</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_part_history') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_part_history')">
                                        <font-awesome-icon :icon="['fas', 'clock-rotate-left']" />
                                        <span class="ms-2" v-if="isExpanded">Parts History</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_parts_spreadsheet_upload') ? 'active' : '',
                                    ]"
                                >
                                    <a
                                        href="#"
                                        @click.prevent="goTo('dash_parts_spreadsheet_upload')"
                                    >
                                        <font-awesome-icon :icon="['fas', 'upload']" />
                                        <span class="ms-2" v-if="isExpanded">Upload Parts</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_shipping_spreadsheet_upload')
                                            ? 'active'
                                            : '',
                                    ]"
                                >
                                    <a
                                        href="#"
                                        @click.prevent="goTo('dash_shipping_spreadsheet_upload')"
                                    >
                                        <font-awesome-icon :icon="['fas', 'truck']" />
                                        <span class="ms-2" v-if="isExpanded">Upload Shipping</span>
                                    </a>
                                </li>
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('dash_shipping') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('dash_shipping')">
                                        <font-awesome-icon :icon="['fas', 'ship']" />
                                        <span class="ms-2" v-if="isExpanded">Shipping</span>
                                    </a>
                                </li>
                            </ul>
                        </transition>
                    </li> -->

                    <!-- Quick Actions -->
                    <!-- More Pages -->
                    <!-- <li class="sidebar-dropdown list-menu">
                        <a href="#" @click="toggleMorePage">
                            <font-awesome-icon :icon="['fas', 'bars']" />
                            <span class="ms-2">More Pages</span>
                            <span class="more-pages-icon" v-if="morePageShow">
                                <font-awesome-icon :icon="['fas', 'angle-up']" />
                            </span>
                            <span class="more-pages-icon" v-else>
                                <font-awesome-icon :icon="['fas', 'angle-down']" />
                            </span>
                        </a>
                    </li>
                    <div v-if="morePageShow" class="ms-4">
                        <li v-for="(page, index) in morePages" :key="index" class="sidebar-dropdown list-menu">
                            <a href="#">
                                <font-awesome-icon :icon="['fas', 'bars']" />
                                <span class="ms-2">{{page.title}}</span>
                            </a>
                        </li>
                    </div> -->
                    <li
                        v-if="isStaff && !isSearchDemo"
                        :class="[
                            'sidebar-dropdown',
                            'list-menu',
                            'has-children',
                            flowConfigurationsOpen ? 'is-open' : '',
                            isFlowConfigurationRoute($route.name) ? 'active' : '',
                        ]"
                    >
                        <a href="#" @click.prevent="toggleFlowConfigurations">
                            <font-awesome-icon :icon="['fas', 'sliders']" />
                            <span class="ms-2" v-if="isExpanded">Flow Configurations</span>
                            <span class="more-pages-icon">
                                <font-awesome-icon
                                    :icon="['fas', flowConfigurationsOpen ? 'angle-up' : 'angle-down']"
                                />
                            </span>
                        </a>
                        <transition name="submenu">
                            <ul
                                v-if="flowConfigurationsOpen"
                                :class="[
                                    'submenu',
                                    isExpanded ? 'submenu-expanded' : 'submenu-collapsed',
                                ]"
                            >
                                <li
                                    :class="[
                                        'sidebar-dropdown',
                                        'list-menu',
                                        isActive('flow-config-live-search') ? 'active' : '',
                                    ]"
                                >
                                    <a href="#" @click.prevent="goTo('flow-config-live-search')">
                                        <font-awesome-icon :icon="['fas', 'tower-broadcast']" />
                                        <span class="ms-2" v-if="isExpanded">Live Search</span>
                                    </a>
                                </li>
                            </ul>
                        </transition>
                    </li>

                    <li class="sidebar-dropdown list-menu" v-if="isStaff && !isRetail && !isSearchDemo">
                        <a href="#" @click="goToAdmin()">
                            <font-awesome-icon :icon="['fas', 'tachometer-alt']" />
                            <span class="ms-2" v-if="isExpanded">Admin</span>
                        </a>
                    </li>
                </ul>
                <div class="quote-button-wrapper" v-if="displayQuotebutton">
                    <button
                        @click="toggleQuoteModal"
                        type="button"
                        class="login-button pill quote-button"
                        :class="{ 'quote-button-collapsed': !isExpanded }"
                        :aria-label="isExpanded ? 'Create quote' : 'Open quote modal'"
                    >
                        <span class="quote-button-icon">
                            <font-awesome-icon :icon="['fas', 'file-invoice-dollar']" />
                        </span>
                        <span v-if="isExpanded" class="quote-button-label">Quote</span>
                    </button>
                </div>
            </div>
            <!-- sidebar-menu  -->
        </div>
    </nav>
</template>

<script>
    import '@/assets/sidebar-style.css'
    import { mapStores } from 'pinia'
    import { useUserStore } from '@/stores/userStore'
    import config from '@/services/config'

    export default {
        name: 'SideBar',
        data() {
            return {
                isExpanded: false,
                morePageShow: false,
                morePages: [
                    { title: 'Parts', url: '' },
                    { title: 'Parts History', url: '' },
                    { title: 'Upload Parts SpreadSheet', url: '' },
                    { title: 'Upload Shippings SpreadSheet', url: '' },
                    { title: 'Shipping Dashboard', url: '' },
                    { title: 'Sales Chart', url: '' },
                    { title: 'Quotes Chart', url: '' },
                    { title: 'Margin Spread', url: '' },
                    { title: 'Margin Chart', url: '' },
                    { title: 'Margin Sale to Quote', url: '' },
                    { title: 'PO & SO', url: '' },
                    { title: 'Purchase', url: '' },
                    { title: 'Pricing Analysis', url: '' },
                    { title: 'Quotes Detail', url: '' },
                    { title: 'Rules', url: '' },
                    { title: 'Rules Detail', url: '' },
                    { title: 'Special Pricing', url: '' },
                    { title: 'Errors', url: '' },
                    { title: 'Shipping Dashboard', url: '' },
                ],
                substitutePages: false,
                dashboardsOpen: false,
                partsOpen: false,
                flowConfigurationsOpen: false,
            }
        },
        created() {
            this.syncSubstituteMenuWithRoute()
            this.syncFlowConfigurationMenuWithRoute()
        },
        watch: {
            '$route.name'() {
                this.syncSubstituteMenuWithRoute()
                this.syncFlowConfigurationMenuWithRoute()
            },
        },
        computed: {
            ...mapStores(useUserStore),
            isStaff() {
                return this.userStore.isStaff
            },
            isRetail() {
                return config.isRetail ? config.isRetail() : config.getSubdomain() === 'retail'
            },
            isSearchDemo() {
                return config.isSearchDemo ? config.isSearchDemo() : false
            },
        },
        props: {
            displayQuotebutton: {
                type: Boolean,
                default: false,
            },
            isBpaNoquote: {
                type: Boolean,
                default: false,
            },
        },
        methods: {
            goToAdmin() {
                const environment = process.env.VUE_APP_ENV
                let adminUrl = window.location.origin

                if (environment == 'dev') {
                    adminUrl = process.env.VUE_APP_BACKEND_URL
                }
                window.open(`${adminUrl}/admin`, '_blank')
            },
            toggleMorePage() {
                this.morePageShow = !this.morePageShow
            },
            toggleDashboards() {
                this.dashboardsOpen = !this.dashboardsOpen
            },
            toggleParts() {
                this.partsOpen = !this.partsOpen
            },
            toggleSubstitutesPages() {
                this.substitutePages = !this.substitutePages
            },
            toggleFlowConfigurations() {
                this.flowConfigurationsOpen = !this.flowConfigurationsOpen
            },
            toggleSidebar() {
                this.isExpanded = !this.isExpanded
            },
            toggleQuoteModal() {
                this.$emit('toggleQuoteModal')
            },
            goTo(destiny) {
                this.$router.push({ name: destiny })
            },
            isActive(routeName) {
                return this.$route.name === routeName
            },
            isSubstitutesRoute(routeName) {
                return ['substitutes-tree', 'substitutes-bad-requests'].includes(routeName)
            },
            isFlowConfigurationRoute(routeName) {
                return ['flow-config-live-search'].includes(routeName)
            },
            syncSubstituteMenuWithRoute() {
                if (this.isSubstitutesRoute(this.$route.name)) {
                    this.substitutePages = true
                }
            },
            syncFlowConfigurationMenuWithRoute() {
                if (this.isFlowConfigurationRoute(this.$route.name)) {
                    this.flowConfigurationsOpen = true
                }
            },
        },
    }
</script>

<style scoped lang="scss">
    .sidebar-wrapper {
        position: fixed;
        top: 0;
        left: var(--shell-sidebar-offset);
        bottom: 0;
        width: var(--shell-sidebar-width);
        height: 100vh;
        max-height: 100vh;
        background: var(--color-surface-canvas);
        box-shadow: var(--shadow-lg);
        display: flex;
        overflow: hidden;
        transition:
            width 0.25s ease,
            box-shadow 0.25s ease;
        z-index: var(--shell-navbar-z);

        &.sidebar-collapsed {
            width: var(--shell-sidebar-width-collapsed);
        }

        .sidebar-content {
            top: 50px;
            width: 100%;
            height: 100%;
            overflow-y: auto;
            overflow-x: hidden;
            padding: 1.5rem;
            background: transparent;
            transition: padding 0.25s ease;

            &.sidebar-content-collapsed {
                padding: 1.25rem 0.75rem;
            }
        }

        .sidebar-toggle {
            position: absolute;
            top: 0.75rem;
            right: 0.75rem;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            border: none;
            background: var(--color-surface-canvas);
            box-shadow: var(--shadow-md);
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: transform 0.2s ease;
            z-index: 1;

            &:hover {
                transform: scale(1.05);
            }
            &:focus {
                outline: none;
                box-shadow: 0 0 0 2px rgba(103, 80, 164, 0.35);
            }
        }

        .sidebar-brand {
            .collapsed-logo {
                .logo-img {
                    max-width: 32px;
                }
            }
        }

        .sidebar-menu {
            ul {
                list-style: none;
                margin: 0;
                padding: 0;
            }

            .has-children {
                display: flex;
                flex-direction: column;
            }

            .list-menu {
                padding: 10px 12px;

                > a {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    border-radius: var(--radius-shell);
                    padding: 10px 14px;
                    transition: background 0.2s ease;

                    svg,
                    span {
                        font-size: 13px;
                        color: var(--color-text-secondary);
                        font-weight: 500;
                    }
                }

                &.active {
                    background: var(--color-accent-soft);
                    border-radius: var(--radius-shell);
                }
            }

            .more-pages-icon {
                float: right;
                display: inline-flex;
                align-items: center;
            }

            .submenu {
                list-style: none;
                margin: 0;
                padding: 0.25rem 0 0;

                &.submenu-expanded {
                    padding-left: 1.5rem;
                }

                &.submenu-collapsed {
                    padding-left: 0;
                }
            }

            .submenu .list-menu {
                padding: 6px 12px;

                > a {
                    padding: 8px 12px;
                }
            }

            .pill {
                border-radius: 40px;
            }
        }

        .searchInputWrapper {
            background: var(--color-accent-soft);
            border-radius: var(--radius-shell);

            .searchInput {
                padding: 25px 0px;
            }
            .searchInputIcon {
                top: 1rem;
            }
        }

        .quote-button-wrapper {
            display: flex;
            justify-content: center;
            margin-top: 1rem;
        }

        .quote-button {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 0.35rem;
        }

        .quote-button-icon {
            display: inline-flex;
            align-items: center;
            margin-right: 0.35rem;
        }

        &.sidebar-collapsed {
            .list-menu {
                padding: 8px 0;

                > a {
                    justify-content: center;
                    padding: 12px 0;

                    svg {
                        margin: 0;
                    }
                }
            }
            .more-pages-icon {
                display: none;
            }

            .list-menu.has-children .more-pages-icon {
                display: inline-flex;
            }

            .submenu {
                width: 100%;
            }

            .submenu .list-menu > a {
                justify-content: center;
            }
        }

        &.sidebar-collapsed {
            .quote-button {
                border-radius: 999px;
                width: 48px;
                height: 48px;
                padding: 0;
            }

            .quote-button-icon {
                margin-right: 0;
            }
        }
    }

    .submenu-enter-active,
    .submenu-leave-active {
        transition: all 0.15s ease;
        overflow: hidden;
    }

    .submenu-enter,
    .submenu-leave-to {
        opacity: 0;
        transform: translateY(-6px);
    }

    @media (max-width: 768px) {
        .sidebar-wrapper {
            top: 0;
            left: 0;
            bottom: 0;
        }
    }
    .not-used-dashboards {
        display: none;
    }
</style>
